import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'movement',
		path: '/m/:movementId',
		component: loadable(async () => import(/* webpackChunkName: "pages/movement" */ './index'), {
			exportName: 'Movement',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
